// extracted by mini-css-extract-plugin
module.exports = {"CardDescription":"CardDescription_CardDescription__BWtMt"};